var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.elements),function(element,key){return _c('lazy-hydrate',{key:_vm.$app.page.alias + key,attrs:{"when-idle":""}},[_c(_vm.sections[element.alias],{tag:"component",attrs:{"prefix":`${_vm.value}.${key}.value`,"value":element.value}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }